import { MapPin, Phone, Clock, Instagram, Facebook, Smartphone } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { ADDRESS, HOURS, PHONE_DISPLAY, PHONE_TEL, MOBILE_DISPLAY, MOBILE_TEL, INSTAGRAM_URL, FACEBOOK_URL, MAP_EMBED } from "../data/content";

const todayIdx = (new Date().getDay() + 6) % 7;

export const Contacts = () => (
  <section id="contatti" className="bg-beige-light py-24 md:py-36" data-testid="contacts-section">
    <div className="container-x">
      <SectionHeading
        id="contacts"
        eyebrow="Contatti"
        title={<>Ti aspettiamo a <em className="font-normal italic text-sage">Reschigliano</em>.</>}
      />
      <div className="mt-16 grid gap-8 lg:grid-cols-12">
        <Reveal className="lg:col-span-7">
          <div className="h-[380px] overflow-hidden rounded-[2rem] border border-sage/10 shadow-[0_30px_60px_-40px_rgba(27,41,33,0.4)] lg:h-full lg:min-h-[520px]">
            <iframe
              title="Mappa Centro Estetico Biovital"
              src={MAP_EMBED}
              className="h-full w-full grayscale-[35%] contrast-[1.05]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
              data-testid="contacts-map"
            />
          </div>
        </Reveal>

        <div className="grid gap-6 lg:col-span-5">
          <Reveal delay={0.1}>
            <div className="rounded-[1.6rem] bg-white p-7 border border-sage/10" data-testid="contacts-address-card">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-sage-pale text-sage"><MapPin className="h-5 w-5" /></span>
              <h3 className="mt-4 font-serif text-2xl text-ink">Dove siamo</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted">{ADDRESS}</p>
              <a href={PHONE_TEL} className="mt-5 inline-flex items-center gap-2 font-semibold text-sage hover:text-gold transition-colors" data-testid="contacts-phone-link">
                <Phone className="h-4 w-4" /> {PHONE_DISPLAY}
              </a>
              <a href={MOBILE_TEL} className="mt-2 flex items-center gap-2 font-semibold text-sage hover:text-gold transition-colors" data-testid="contacts-mobile-link">
                <Smartphone className="h-4 w-4" /> {MOBILE_DISPLAY}
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.2}>
            <div className="rounded-[1.6rem] bg-sage-dark p-7 text-cream" data-testid="contacts-hours-card">
              <div className="flex items-center justify-between">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-cream/10 text-gold-light"><Clock className="h-5 w-5" /></span>
                <span className="text-[10px] uppercase tracking-[0.25em] text-cream/50">Orari di apertura</span>
              </div>
              <ul className="mt-5 divide-y divide-cream/10">
                {HOURS.map((h, i) => (
                  <li key={h.day} className={`flex items-center justify-between py-2.5 text-sm ${i === todayIdx ? "text-gold-light font-semibold" : h.closed ? "text-cream/40" : "text-cream/85"}`} data-testid={`hours-${h.day.toLowerCase()}`}>
                    <span>{h.day}{i === todayIdx && <span className="ml-2 text-[9px] uppercase tracking-widest">oggi</span>}</span>
                    <span className="font-medium tabular-nums">{h.hours}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.3} className="flex gap-3">
            <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" className="flex flex-1 items-center justify-center gap-2 rounded-full border border-sage/15 bg-white py-3.5 text-sm font-semibold text-sage transition-[background-color,color] hover:bg-sage hover:text-white" data-testid="contacts-instagram-link">
              <Instagram className="h-4 w-4" /> Instagram
            </a>
            <a href={FACEBOOK_URL} target="_blank" rel="noreferrer" className="flex flex-1 items-center justify-center gap-2 rounded-full border border-sage/15 bg-white py-3.5 text-sm font-semibold text-sage transition-[background-color,color] hover:bg-sage hover:text-white" data-testid="contacts-facebook-link">
              <Facebook className="h-4 w-4" /> Facebook
            </a>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
